<template>
    <div class="kt-portlet">
        <div class="kt-portlet__body" style="color: black; background-color: #fff">
            <h6>{{TitleMarketersNumber}}</h6>
            <div class="text-center">
                <h4 class="fix-margin">
                    {{MarketersNumber}}
                </h4>
            </div>
            <div class="line-divider mt-4 mb-3"></div>
            <div class="row">
                <div class="col-md-6 col-lg-6 col-sm-6 border-right">
                    <div class="mb-3" style="font-size: 0.82rem">
                        {{TitleRegisteredUsers}}
                    </div>
                    <div class="text-center">
                        <h4 class="fix-margin">
                            {{RegisteredNumber}}
                        </h4>
                    </div>
                </div>
                <div class="col-md-6 col-lg-6 col-sm-6">
                    <div class="mb-3" style="font-size: 0.82rem">
                        {{TitleTotalClicks}}
                    </div>
                    <div class="text-center">
                        <h4 class="fix-margin">
                            {{TotalClicks}}
                        </h4>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>

    export default {
        name: "",

        props: {
            TitleMarketersNumber: {
                default() {
                    return {}
                }
            },
            TitleRegisteredUsers: {
                default() {
                    return {}
                }
            },
            TitleTotalClicks: {
                default() {
                    return {}
                }
            },
            MarketersNumber: {
                default() {
                    return {}
                }
            },
            RegisteredNumber: {
                default() {
                    return {}
                }
            },
            TotalClicks: {
                default() {
                    return {}
                }
            },
        },

    }
</script>

<style>

</style>